/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface CopyProps extends React.SVGAttributes<SVGElement> {
size?: string | number;
}
const Copy: React.FC<CopyProps> = ({size, ...props}) => (
  <svg viewBox="0 0 40 40" fill="currentColor" width={ size || "40" } height={ size || "40" } {...props}>
    <path d="M27.4748 27.7579H27.7977C29.7401 27.7579 31 26.6744 31 24.4049V14.7583H25.3444C24.3117 14.7583 23.6833 14.1222 23.6833 13.0849V7H18.2606C16.1495 7 14.9948 8.16072 14.9948 10.2657V10.7545H16.544C18.1082 10.7545 19.2653 11.1239 20.3888 12.2595L26.1194 18.0549C27.2192 19.175 27.4748 20.4324 27.4748 21.9421V27.7579ZM25.6089 13.3887H30.8388C30.7957 13.0395 30.5444 12.7294 30.162 12.3367L26.0661 8.08959C25.7028 7.69954 25.3847 7.44892 25.0444 7.41171L25.0527 12.8069C25.0527 13.2149 25.2059 13.3887 25.6089 13.3887Z"
      fill="#fff" />
    <path d="M13.2786 33H22.7284C24.8908 33 26.0071 31.8448 26.0071 29.647V21.7121H18.8277C17.5363 21.7121 16.9088 21.0683 16.9088 19.7674V12.2421H13.2786C11.1244 12.2421 10 13.387 10 15.595V29.647C10 31.855 11.1162 33 13.2786 33ZM18.9266 20.2179L25.818 20.2142C25.708 19.7825 25.4486 19.3703 24.9834 18.891L19.6669 13.4226C19.2081 12.9479 18.8082 12.6303 18.3762 12.5013V19.6617C18.3762 20.0276 18.5689 20.2179 18.9266 20.2179Z"
      fill="#fff" />
  </svg>
);
Copy.displayName = 'Copy';
export default Copy;
/* tslint:enable */
/* eslint-enable */
